import { Menu } from '@headlessui/react'
import React, { Fragment, useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'

import { classNames } from '../../../functions'
import { useDebounce } from '../../../hooks/utils'
import { updateTheme } from '../../../state/application/actions'
import { useTheme } from '../../../state/application/hooks'
import { Theme } from '../../../state/application/reducer'
import { AnimationTransition } from '../../Animation'
import { ThemeIcon } from '../../Icons'

const THEMES = ['light', 'dark', 'dank']

/**
 * @return {Theme} theme light or dark
 */
export default function ThemeSwitch() {
  const currentTheme = useTheme()
  const dispatch = useDispatch()
  const [debouncedHover, setDebouncedHover] = useState(false)
  const [hover, setHover] = useState(false)
  const DebouncedHover = useDebounce([debouncedHover, hover], 200)

  useEffect(() => {
    const [debouncedHover] = DebouncedHover
    setHover(debouncedHover)
  }, [DebouncedHover])

  return (
    <Menu
      as="div"
      className="relative group"
      onMouseEnter={() => {
        setHover(true)
        setDebouncedHover(true)
      }}
      onMouseLeave={() => setDebouncedHover(false)}
      key={currentTheme}
    >
      <>
        <Menu.Button
          as="div"
          className="grid items-center p-1 text-sm font-bold duration-500 ease-in-out rounded-lg group-hover:bg-polling bg-buttonbg align-center focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-transparent focus:ring-transparent"
        >
          <ThemeIcon theme={currentTheme} width={22} height={22} />
        </Menu.Button>
        <AnimationTransition show={hover}>
          <Menu.Items
            as="div"
            className="overflow-auto group px-2 py-2 gap-x-4 w-fit-content border z-50 border-orange-500 rounded-lg landscape:flex -translate-x-[27%] landscape:-translate-x-[41%] origin-center shadow-lg grid absolute mt-2.5 ring-1 ring-opacity-5 focus:outline-none"
          >
            {THEMES.map((theme) => {
              return (
                <Menu.Button
                  key={theme}
                  onClick={() => {
                    setHover(false)
                    setDebouncedHover(false)
                    dispatch(updateTheme({ theme: theme as Theme }))
                  }}
                  as="div"
                  className={classNames(
                    theme === currentTheme ? 'bg-polling' : '',
                    'duration-500 ease-in-out hover:bg-pollingactive rounded-lg cursor-pointer z-50 text-sm group items-center w-full flex px-2 py-4 landscape:py-0 text-primary'
                  )}
                >
                  <ThemeIcon theme={theme} width={22} height={22} />
                </Menu.Button>
              )
            })}
            <div className="top-0 left-0 custom-backdrop-blur z-1" />
          </Menu.Items>
        </AnimationTransition>
      </>
    </Menu>
  )
}
